export default "__VITE_ASSET__Drq3koMU__"